import "moment";

const Accounts = {
    getParentAccount: function( id, collection ) {

        var getParent = function( accId, accounts ) {

            let hasTheAccount = false;

            _.forEach( accounts, ( v ) => {
                if ( v.hasOwnProperty("subAccounts") ) {
                    let find = _.find( v.subAccounts, ( item ) => item.id == accId );
                    if ( _.some( v.subAccounts, ( item ) => item.id == accId ) ) {
                        hasTheAccount = v.id;
                        return false;
                    } else {
                        hasTheAccount = getParent( accId, v.subAccounts );
                    }
                }
            });

            return hasTheAccount;
        }

        return getParent( id, collection );
    }
};

export default Accounts;
